import { render, staticRenderFns } from "./HrSalarySettlementDetails.vue?vue&type=template&id=7942bf82&lang=pug&"
import script from "./HrSalarySettlementDetails.vue?vue&type=script&lang=js&"
export * from "./HrSalarySettlementDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrSalarySettlementDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VDataTable,
  VFlex,
  VLayout,
  VSubheader,
})
